import { createContext } from 'react';
export const TelemetryContext = createContext(null);
